export const GROUP_NAMES = {
  POPULAR_SEARCHES: 'popular searches',
  POPULAR_CATEGORIES: 'popular categories',
  SUGGESTED_SEARCHES: 'suggested searches',
  RELATED_CATEGORIES: 'related categories',
  RELATED_PRODUCTS: 'related products',
  RELATED_CONTENT: 'related content',
}

export const trackClickedItem = (label: string, url: string, index?: number, groupType?: string) => {
  return {
    label,
    position: index === undefined ? undefined : index + 1,
    url,
    type: groupType,
  }
}
